import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Product} from '../models/product';
import {error} from '..';
import {ProductsService} from '../services/products-List.service';
import {LoadProductsCompleteListFailAction, LoadProductsCompleteListSuccessAction, productsCompleteListActionTypes} from '../actions/product-complete-list';
import {L10nTranslationService} from 'angular-l10n';
import {LoadProductsSuccessAction, productsActionTypes} from '../actions/product';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class ProductsCompleteListEffect extends BaseEffect {


  // load$ =  createEffect(() => { return this.actions$.pipe(
  //   ofType(productsCompleteListActionTypes.LOAD),
  //   debug('Products complete list load action received.'),
  //   switchMap(() => this.productsService.getListAll().pipe(
  //     map((payload: SendBackResult<ArrayResponse<Product>>) => new LoadProductsCompleteListSuccessAction(payload.data.array)),
  //     catchError(res => this.catchResponseError(res)),
  //   ))
  // )});
  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(productsCompleteListActionTypes.LOAD),
      debug('Products complete list load action received.'),
      switchMap(() => {
        const cacheKey = 'products';
        const cached = this.apiCacheService.get<Product[]>(cacheKey);

        if (cached) {
          return of(new LoadProductsCompleteListSuccessAction(cached));
        }

        return this.productsService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Product>>) => {
            const products = payload.data.array;
            this.apiCacheService.set(cacheKey, products);
            return new LoadProductsCompleteListSuccessAction(products);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });

  loadFail$ =  createEffect(() => { return this.actions$.pipe(
    ofType(productsCompleteListActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving products complete list.'),
    map((action: LoadProductsCompleteListFailAction) =>
      error(this.translation.translate('PRODUCTS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  )});

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private productsService: ProductsService,
              private apiCacheService: ApiCacheService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadProductsCompleteListFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadProductsCompleteListFailAction(response['error'].message);
  }
}
